// extracted by mini-css-extract-plugin
export var infoItem = "_uk-2";
export var title = "_uk-0";
export var value = "_uk-1";